<template>
  <div>
    <b-row>

      <b-col
          md="4"
          v-for="(payment, index) in incomingInvoice.bankOperations"
          :key="index"
      >
        <payment-content
            :payment="payment"
            @edit="selectPayment('incomingInvoice', incomingInvoice, payment)"
            @delete="deletePayment(index)"
        />
      </b-col>

      <b-col md="4">
        <add-content
            @click="addPayment('incomingInvoice', incomingInvoice)"
        />
      </b-col>

    </b-row>


    <!-- modal payment-->
    <modal-payment
        :is-select-form="false"
        :payment.sync="currentPayment"
        :title="paymentModalTitle"
        :isOpen.sync="paymentModalShow"
        :absoluteDisplay="false"
        @submitValidatedPayment="submitPayment"
    />
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mixinPayments } from '../../../../mixins/mixinPayments'

import PaymentContent from '../../../card/components/PaymentContent'
import AddContent from '../../../card/components/New'
import store from '@/store'
import useAPI from '../../../../utils/useAPI'

export default {
  components: {
    PaymentContent,
    AddContent
  },
  mixins: [mixinPayments],
  props: {
    incomingInvoice: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { bankAccounts } = useAPI()

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const getBankOperationDetail = (boId) => {
      let output = null
      bankAccounts.value.forEach(ba => {
        ba.bankOperations.forEach(bo => {
          if (bo.id == boId) {
            output = bo
          }
        })
      })

      return output
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
      getBankOperationDetail,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    submitPayment () {
      if ('id' in this.currentPayment) {
        let index = this.incomingInvoice.bankOperations.findIndex(bo => bo.id == this.currentPayment.id)
        this.incomingInvoice.bankOperations.splice(index, 1, JSON.parse(JSON.stringify(this.currentPayment)))
      } else {
        this.currentPayment._balance = this.currentPayment.credit - this.currentPayment.debit
        this.currentPayment.paymentMethod = store.getters['paymentMethod/getPaymentMethod'](this.currentPayment.paymentMethod)

        this.incomingInvoice.bankOperations.push(this.currentPayment)
        // this.incomingInvoice.bankOperations.push(this.getBankOperationDetail(this.currentPayment.id))

      }

      this.paymentModalShow = false
    },
    deletePayment (paymentIndex) {
      this.incomingInvoice.bankOperations.splice(paymentIndex, 1)
      console.log(this.incomingInvoice.bankOperations)
    },
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>